import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StringsService } from '../../services/strings/strings.service';
import { ReschedulePage } from '../../types/strings.type';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { ReservationService } from '../../services/reservation/reservation.service';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Utilities } from '../../../shared/utilities/utilities';
import { Journey } from '../../../shared/types/strings.type';

@Component({
    selector: 'rttd-booking-reschedule',
    templateUrl: './booking-reschedule.component.html',
    styleUrls: ['./booking-reschedule.component.scss'],
})
export class BookingRescheduleComponent implements OnInit {

    content: ReschedulePage;
    showBack = false;
    allowOffsite = this.appSettings.allowOffSite;
    isOffsite = this.userSelectionService.get('startLocation') === this.utilities.startLocationAsString('off');
    bookingStartTime: Date;

    header: Journey = {
        title: 'Book a Test Drive.',
        instruction: 'Reschedule your test drive experience.'
    };

    constructor(
        private stringsService: StringsService,
        public activatedRoute: ActivatedRoute,
        public appSettings: AppSettings,
        private reservationService: ReservationService,
        private userSelectionService: UserSelectionsService,
        private router: Router,
        private utilities: Utilities
    ) {
    }

    ngOnInit() {
        this.bookingStartTime = this.userSelectionService.get('startTime');
        this.stringsService.get().subscribe((content: ReschedulePage) => this.content = content['ReschedulePage'])
      }

    /**
     * @description Reschedule the reservation.
     *
     * Calls reservationService.rescheduleReservation() to reschedule the currently stored
     * reservation.
     */
    rescheduleBooking() {
        this.reservationService.rescheduleReservation().subscribe(res => {
            this.navigateToConfirmation();
        });
    }

    isOffSite($event: boolean) {
        this.isOffsite = $event;
    }

    private navigateToConfirmation() {
        this.router.navigate(['/booking-confirmation'], {
            skipLocationChange: true
        });
    }

}
